import { RevealBlock } from "./Reveal";

const chapters = [
  {
    n: "01",
    title: "Presence over paperwork.",
    body: "Every post begins with a briefing, ends with a signed log, and is walked in between. No absentee guarding.",
  },
  {
    n: "02",
    title: "De-escalation is the cheapest tool.",
    body: "Force is a last resort — and always the most expensive. We hire for temperament first, physique second.",
  },
  {
    n: "03",
    title: "Local knowledge is a security asset.",
    body: "Our roster lives across Nova Scotia. Halifax teams know Halifax. Cape Breton teams know Cape Breton. That's not marketing — that's operational integrity.",
  },
  {
    n: "04",
    title: "Weather is a variable, not an excuse.",
    body: "Nor'easters, ice storms, marine fog, hurricane season — we build seasonal rosters that assume Atlantic Canada, not Toronto.",
  },
  {
    n: "05",
    title: "Reports you'll actually read.",
    body: "Daily activity reports, incident reports, and monthly analytics designed by editors, not by insurance forms. Clear enough for your board.",
  },
  {
    n: "06",
    title: "Bonded, insured, audited.",
    body: "Licensed under the Nova Scotia Security and Investigative Services Act, $5M commercial general liability, WCB in good standing.",
  },
];

export default function Manifesto() {
  return (
    <section id="manifesto" className="relative bg-[#F5F3EF] py-24 md:py-40">
      <div className="max-w-[1600px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-12 gap-4 mb-16 md:mb-24">
          <div className="col-span-12 md:col-span-3">
            <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-[#C17A43] mb-6">
              — Manifesto
            </p>
          </div>
          <div className="col-span-12 md:col-span-9">
            <RevealBlock>
              <h2 className="font-serif text-[clamp(2.5rem,6vw,6rem)] leading-[0.9] tracking-tighter text-[#111111]">
                Six principles.<br />
                <span className="italic text-[#184C59]">No exceptions.</span>
              </h2>
            </RevealBlock>
          </div>
        </div>

        <div className="border-t border-[#D9D6D0]">
          {chapters.map((c, i) => (
            <RevealBlock key={c.n} delay={i * 0.08}>
              <div className="grid grid-cols-12 gap-4 md:gap-8 py-10 md:py-14 border-b border-[#D9D6D0] group">
                <div className="col-span-2 md:col-span-2">
                  <p className="font-mono text-sm md:text-base text-[#C17A43]">
                    {c.n}
                  </p>
                </div>
                <div className="col-span-10 md:col-span-6">
                  <h3 className="font-serif text-2xl md:text-4xl leading-tight tracking-tight text-[#111111] group-hover:italic transition-[font-style] duration-300">
                    {c.title}
                  </h3>
                </div>
                <div className="col-span-12 md:col-span-4 md:pl-8">
                  <p className="font-sans text-sm md:text-base text-[#111111]/70 leading-relaxed">
                    {c.body}
                  </p>
                </div>
              </div>
            </RevealBlock>
          ))}
        </div>
      </div>
    </section>
  );
}
